/*
 * Copyright (c) 2023 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ReactGA from "react-ga4";

import './custom.scss';

import HUBIntl from 'HUB/satellites/nls/HUBIntl';
import HUBCookiesConsent from 'HUB/satellites/utils/HUBCookiesConsent';

import YSNLS from 'YS/nls/YSNLS';
import YSConfig from 'YS/conf/YSConfig';

import ThemeProvider from 'YS/ui/ThemeProvider.tsx';

HUBIntl._supportedLocales = YSNLS.SUPPORTED_LANGS;
HUBIntl._strings = YSNLS.s;
HUBIntl._documents = YSNLS.documents;


if (HUBCookiesConsent.hasActiveConsent()){
  ReactGA.gtag("consent", "default", {
     ad_storage: "denied",
     ad_user_data: "denied",
     ad_personalization: "denied",
     analytics_storage: "granted",
   });
} else {
  ReactGA.gtag("consent", "default", {
     ad_storage: "denied",
     ad_user_data: "denied",
     ad_personalization: "denied",
     analytics_storage: "denied",
   });
}
ReactGA.initialize(YSConfig.GA_MEASUREMENT_ID);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
